module.exports = __webpack_public_path__ + "static/media/RawInquiryImport.98f12725.xlsx";